import { motion } from "framer-motion";
import "./Loading.css";

export default function Loading() {
  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <img className="loading-logo" src="memoji.png" alt=""></img>
      <div className="loading-bar"></div>
    </motion.div>
  );
}